import { CheckCircle } from 'lucide-react';

const benefits = [
  'Access to international buyer requirements',
  'Multi-category sourcing opportunities',
  'Long-term buyer relationships',
  'Export guidance and coordination',
  'Quality and compliance alignment',
];

const SupplierBenefits = () => (
  <>
    <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0B2A57] mb-6" style={{ fontFamily: 'Cabinet Grotesk' }}>
      Why Register With Taiga?
    </h2>
    <p className="text-base text-[#6B7280] leading-relaxed mb-8">
      Taiga Sourcing connects suitable Indian manufacturers with international buyer requirements. Register your manufacturing capabilities and we will match them with relevant sourcing requests.
    </p>
    <div className="space-y-4">
      {benefits.map((item) => (
        <div key={item} className="flex items-start gap-3">
          <CheckCircle size={18} className="text-[#1E3D66] flex-shrink-0 mt-0.5" />
          <span className="text-sm text-[#6B7280]">{item}</span>
        </div>
      ))}
    </div>
  </>
);

export default SupplierBenefits;
